import getters from "./EtudeFinanciereGetters";
import actions from "./EtudeFinanciereActions";
import mutations from "./EtudeFinanciereMutations";

const state = {
    programmeDinvestissementPlanDeFinancement: {},
    chargePrevisionnel: {},
    caDetails: {},
    achatsPrevisionnel: {},
    autresCharges: [],
    fonctions: [],
    TauxEvolutionChiffre: 0,
    TauxRealisationChiffre: 0,
    tauxRealisationAchats: 0,
    tauxEvolutionAchats: 0
};

export default {
    state,
    getters,
    actions,
    mutations
};
